export default __webpack_public_path__ + "static/media/Career.7ad0a714.svg";